module.exports = __webpack_public_path__ + "static/media/chart1.1a0c352a.png";